import LoanApplicationsView from "../../../jsx/components/Dashboard/LoanApplications/loanapplicationsview";

const LoanApplicatiionsWrapper = () => {
  return <LoanApplicationsView />;
};

export default constore(LoanApplicatiionsWrapper);
